










import { defineComponent } from '@vue/composition-api';
import useAuth from '@/useAuth';

import PageColumnWithVisitorEditor from '@/components/Visitor/PageColumnWithVisitorEditor.vue';

const Edit = defineComponent({
  components: {
    PageColumnWithVisitorEditor,
  },
  setup() {
    const { hasPermission } = useAuth();
    return {
      hasPermission,
    };
  },
});

export default Edit;
